export default __webpack_public_path__ + "static/media/img2.09ef822a.jpg";